export enum DisplayMode {
    darkMode = 'dark-mode',
    lightMode = 'light-mode',
}
